import { Article } from '@/components/molecules';

type TermsOfServiceProps = {
  scrollable?: boolean;
};

const TermsOfService = ({ scrollable }: TermsOfServiceProps) => {
  return (
    <>
      <Article title="제 1조 (목적)">
        본 약관은 주식회사 핀카(이하 ‘회사’라 함)가 제공하는 서비스의 이용과 관련하여 기본적인 사항을 정함으로써 회사와 이용자의 권리, 의무 및
        책임사항을 규정함을 목적으로 합니다.
      </Article>
      <Article title="제 2조 (용어의 정의)">
        <ol>
          <li>
            &quot;핀카 비즈 센터&quot;라 함은, 자동차 자산관리 및 비즈니스에 필요한 다양한 기능을 종합적 편의를 제공하는 시스템(이하 ‘서비스’)을
            말합니다.
          </li>
          <li>&quot;개인회원&quot;이라 함은, 아이디(이메일), 비밀번호 등록을 통해 회원가입을 개인을 의미합니다.</li>
          <li>&quot;기업회원&quot;이라 함은, 회원가입 후 특정 회사의 소속뙨 개인회원을 의미합니다.</li>
          <li>&quot;이용자&quot;라 함은, 본 약관에 따라 회원가입을 완료하고 회사가 제공하는 서비스를 이용하는 개인 또는 기업회원을 의미합니다.</li>
          <li>
            &quot;게시물&quot;이란, &quot;이용자&quot;가 &quot;서비스&quot;를 이용함에 있어 &quot;서비스상&quot;에 게시한
            부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.
          </li>
          <li>&quot;청구&quot;란, &quot;서비스&quot; 이용시 발생되는 비용을 계약된 기간 단위로 계산하여 지불을 요청 하는 것을 의미합니다.</li>
          <li>&quot;결제&quot;라 함은, &quot;청구&quot;된 내역에 대하여 비용을 지불하는 것을 의미합니다.</li>
        </ol>
      </Article>
      <Article title="제 3조 (약관의 명시와 개정)">
        <ol>
          <li>회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 화면 내 또는 별도의 연결화면에 게시하거나 팝업화면 등으로 게시합니다.</li>
          <li>
            회사는 약관의 규제에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관련법령을
            위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
          </li>
          <li>
            회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 본 제 1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터
            적용일자 전까지 공지합니다. 다만, 이용자의 권리 또는 의무에 관한 중요한 사항의 변경 또는 이용자에게 불리한 약관의 변경은 최소한 30일 전에
            공지하고 이용자 사전에 등록한 전화, 메일, 문자메시지 등의 전자적 수단을 통해 별도로 명확히 통지하도록 합니다.
          </li>
          <li>
            회사가 본 제 3항에 따라 개정약관을 공지 또는 통지하면서 이용자에게 약관 변경 적용일까지 거부의사를 표시하지 않으면 동의한 것으로 본다는
            뜻을 명확하게 공지 또는 통지하였음에도 이용자가 명시적으로 거부의 의사표시를 하지 아니한 경우 이용자가 개정약관에 동의한 것으로 봅니다.
          </li>
          <li>
            이용자는 개정된 약관에 대해 동의하지 않을 권리가 있으며 이용자가 개정약관의 적용에 동의하지 않을 경우 이용자는 이용계약을 해지할 수
            있습니다. 회사는 개정약관 적용에 동의하지 않는 이용자에 대해서는 기존 약관을 적용하되, 기존 약관을 적용할 수 없는 특별한 사정이 있는
            경우에는 이용계약을 해지할 수 있습니다.
          </li>
          <li>
            본 약관은 이용자가 약관의 내용에 동의함으로써 효력이 발생하여 이용계약 종료일까지 적용됩니다. 단, 채권 또는 채무관계가 있을 경우에는 채권,
            채무의 완료일까지로 규정합니다.
          </li>
        </ol>
      </Article>
      <Article title="제 4조 (약관 외 준칙)">
        <ol>
          <li>
            본 약관에서 정하지 않은 사항과 본 약관의 해석에 관하여는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자 보호에
            관한 법률, 약관의 규제에 관한 법률 및 기타 관계법령 또는 상관례에 다릅니다.
          </li>
        </ol>
      </Article>
      <Article title="제 5조 (서비스 이용계약의 체결)">
        <ol>
          <li>
            이용계약은 이용자가 약관의 내용에 대하여 동의를 한 다음 회사가 제시하는 양식과 절차에 따라 이용신청을 하고 회사가 이러한 신청에 대하여
            승낙함으로써 체결됩니다.
          </li>
          <li>
            회사는 이용자의 서비스 이용 신청에 대하여 서비스 이용 승낙을 원칙으로 합니다. 다만, 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을
            하지 않거나 사후에 이용계약을 해지할 수 있습니다.
          </li>
          <ul>
            <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
            <li>만 14세 미만의 신청자인 경우</li>
            <li>허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
            <li>이용자가 상실되었거나 이용계약이 해제되었던 경우</li>
            <li>이용자가 서비스의 정상적인 제공을 저해하거나 다른 이용자의 서비스 이용에 지장을 줄 것으로 예상되는 경우</li>
            <li>이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
            <li>기타 이 약관에 위배되거나 위법 또는 부당한 가입신청임이 확인된 경우</li>
          </ul>
          <li>
            이용자는 서비스 이용을 위해 허위 사실이 없는 진실된 정보를 제공하여야 하며, 회사는 제공하는 서비스 상품에 따라 필요한 경우 이용자에게 추가
            정보를 요청할 수 있습니다.
          </li>
          <li>회사와 이용자가 서비스 이용에 관하여 별도 계약을 체결한 경우, 해당 별도 계약이 본 약관에 우선하여 적용됩니다.</li>
        </ol>
      </Article>
      <Article title="제 6조 (회원 계정(ID) 및 비밀번호)">
        <ol>
          <li>
            회사는 회원에 대하여 회원의 정보 보호, 서비스 이용안내 등의 편의를 위해 회원이 선정한 일정한 문자, 숫자 또는 특수문자의 조합을 계정으로
            부여합니다.
          </li>
          <li>회사는 계정정보를 통하여 당해 회원의 서비스 이용가능 여부 등의 제반 회원 관리업무를 수행합니다.</li>
          <li>
            회원은 자신의 계정정보를 선량한 관리자로서의 주의 의무를 다하여 관리하여야 합니다. 회원이 본인의 계정정보를 소홀히 관리하거나 제3자에게
            이용을 승낙함으로써 발생하는 손해에 대하여는 회원에게 책임이 있습니다.
          </li>
          <li>비밀번호의 관리책임은 회원에게 있으며, 회원이 원하는 경우에는 보안상의 이유 등으로 언제든지 변경이 가능합니다.</li>
          <li>회원은 정기적으로 비밀번호를 변경하여야 합니다.</li>
        </ol>
      </Article>
      <Article title="제 7조 (회원 정보의 수집)">
        <ol>
          <li>
            회사는 이용계약을 위하여 회원이 제공한 정보 외에도 수집목적 또는 이용목적을 밝혀 회원으로부터 필요한 정보를 수집할 수 있습니다. 이 경우,
            회사는 회원으로부터 정보수집에 대한 동의를 받습니다.
          </li>
          <li>
            회사가 정보수집을 위하여 회원의 동의를 받는 경우, 회사는 수집하는 개인정보의 항목 및 수집방법, 수집목적 및 이용목적, 개인정보의 보유 및
            이용기간, 제3자에 대한 정보제공 사항(제공받는 자, 제공받는 자의 이용목적, 제공정보의 항목, 보유 및 이용기간)을 개인정보처리방침으로 미리
            명시하거나 고지합니다. 회원은 정보제공에 동의하더라도 언제든지 그 동의를 철회할 수 있습니다.
          </li>
          <li>회원은 회사에게 정보를 제공하고자 하는 경우 사실대로 제공하여야 합니다.</li>
        </ol>
      </Article>
      <Article title="제 8조 (회원 정보의 제공 및 변경)">
        <ol>
          <li>
            회원은 이 약관에 의하여 회사에 정보를 제공하여야 하는 경우에는 진실된 정보를 제공하여야 하며, 허위정보 제공으로 인해 발생한 불이익에
            대해서는 보호받지 못합니다.
          </li>
          <li>
            회원은 개인정보관리화면을 통하여 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 계정(ID)
            등은 수정이 불가능합니다.
          </li>
          <li>
            회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 기타 방법으로 회사에 대하여 그 변경사항을 알려야 합니다.
          </li>
          <li>제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.</li>
        </ol>
      </Article>
      <Article title="제 9조 (개인정보의 보호 및 관리)">
        <ol>
          <li>
            회사는 관계 법령이 정하는 바에 따라 계정정보를 포함한 회원의 개인정보를 보호하기 위해 노력합니다. 회원 개인정보의 보호 및 사용에 대해서는
            관계법령 및 회사가 별도로 고지하는 개인정보처리방침이 적용됩니다.
          </li>
          <li>
            서비스의 일부로 제공되는 개별 서비스를 제외한 것으로서 홈페이지 및 서비스별 웹사이트에서 단순히 링크된 제3자 제공의 서비스에 대하여는
            회사의 개인정보처리방침이 적용되지 않습니다.
          </li>
          <li>회사는 회원의 귀책사유로 인하여 노출된 회원의 계정정보를 포함한 모든 정보에 대해서 일체의 책임을 지지 않습니다.</li>
        </ol>
      </Article>
      <Article title="제 10조 (개인정보의 위탁)">
        <ol>
          <li>
            회사는 수집된 개인정보의 처리 및 관리 등의 업무를 처리하기 위하여 필요한 경우 업무의 일부 또는 전부를 회원의 동의를 받은 &quot;개인정보의
            위탁&quot;에 따라 위탁할 수 있습니다.
          </li>
        </ol>
      </Article>
      <Article title="제 11조 (회사의 의무)">
        <ol>
          <li>회사는 관련 법령을 준수하고, 이 약관이 정하는 권리의 행사와 의무의 이행을 신의에 따라 성실하게 합니다.</li>
          <li>
            회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고
            준수합니다. 회사는 이 약관 및 개인정보처리방침에서 정한 경우를 제외하고는 회원의 개인정보가 제3자에게 공개 또는 제공되지 않도록 합니다.
          </li>
          <li>
            회사는 계속적이고 안정적인 서비스의 제공을 위하여 서비스 개선을 하던 중 설비에 장애가 생기거나 데이터 등이 멸실된 때에는 천재지변,
            비상사태, 현재의 기술로는 해결이 불가능한 결함 및 장애 등 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구하도록 최선의 노력을
            다합니다.
          </li>
        </ol>
      </Article>
      <Article title="제 12조 (회원이용자의 의무)">
        <ol>
          <li>회원은 다음 행위를 하여서는 안 됩니다.</li>
          <ul>
            <li>가입신청 또는 변경 시 허위내용의 기재</li>
            <li>타인의 정보도용</li>
            <li>회사의 임직원, 운영자, 기타 관계자를 사칭하는 행위</li>
            <li>회사가 게시한 정보의 변경</li>
            <li>회사가 금지한 정보(컴퓨터 프로그램 등)의 송·수신</li>
            <li>회사가 제공 또는 승인하지 아니한 컴퓨터 프로그램이나 기기 또는 장치를 제작, 배포, 이용, 광고하는 행위</li>
            <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
            <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            <li>외설 또는 폭력적인 말이나 글, 화상, 음향, 기타 공서양속에 반하는 정보 등을 타인에게 유포하는 행위</li>
            <li>서비스 데이터를 유상으로 처분하거나 권리의 객체로 하는 행위</li>
            <li>9호의 행위를 유도하거나 광고하는 행위</li>
            <li>회사의 동의 없이 영리, 영업, 광고, 정치활동 등을 목적으로 서비스를 사용하는 행위</li>
            <li>기타 관련 법령에서 금지하거나 선량한 풍속 기타 사회통념상 허용되지 않는 행위</li>
          </ul>
          <li>회원은 이 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 확인하고 준수할 의무가 있습니다.</li>
          <li>
            회사는 제1항, 제2항 및 다음 각 호의 어느 하나에 해당하는 행위의 구체적인 유형을 운영정책에서 정할 수 있으며, 회원은 이를 준수할 의무가
            있습니다.
            <ul>
              <li>회원의 계정명, 기타 서비스상 사용하는 명칭에 대한 제한</li>
            </ul>
          </li>
        </ol>
      </Article>
      <Article title="제 13조 (서비스의 변경 및 내용수정)">
        <ol>
          <li>이용자는 회사가 제공하는 서비스를 이 약관, 운영정책 및 회사가 설정한 서비스규칙에 따라 이용할 수 있습니다.</li>
          <li>회사는 서비스 내용의 제작, 변경, 유지, 보수에 관한 포괄적인 권한을 가집니다.</li>
          <li>
            회사가 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 서비스 수정을 할 수 있으며, 서비스 수정을 하는 경우에는 변경 후 해당 서비스
            화면 등을 통하여 공지합니다.
          </li>
        </ol>
      </Article>
      <Article title="제 14조 (서비스의 제공 및 중단 등)">
        <ol>
          <li>회사는 영업방침에 따라 정해진 시간 동안 서비스를 제공합니다.</li>
          <li>
            제1항에도 불구하고, 다음 각 호의 어느 하나에 해당하는 경우에는 일정한 시간 동안 서비스가 제공되지 아니할 수 있으며, 해당 시간 동안 회사는
            서비스를 제공할 의무가 없습니다.
          </li>
          <ul>
            <li>컴퓨터 등 정보통신설비의 보수점검, 교체, 정기점검 또는 서비스 내용이나 서비스의 수정을 위하여 필요한 경우</li>
            <li>
              해킹 등의 전자적 침해사고, 통신사고, 회원들의 비정상적인 서비스 이용행태, 미처 예상하지 못한 서비스의 불안정성에 대응하기 위하여 필요한
              경우
            </li>
            <li>관련 법령에서 특정 시간 또는 방법으로 서비스 제공을 금지하는 경우</li>
            <li />
          </ul>
          <li>
            회사는 제2항 제1호의 경우, 매주 또는 격주 단위로 일정 시간을 정하여 서비스를 중지할 수 있습니다. 이 경우 회사는 최소한 24시간 전에 그
            사실을 회원에게 서비스 초기 화면이나 서비스 홈페이지에 고지합니다.
          </li>
          <li>
            제2항 제2호의 경우, 회사는 사전 고지 없이 서비스를 일시 중지할 수 있습니다. 회사는 이러한 경우 그 사실을 서비스 초기 화면이나 서비스
            홈페이지에 사후 고지할 수 있습니다.
          </li>
          <li>
            회사는 회사가 제공하는 무료서비스 이용과 관련하여 이용자에게 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다. 다만, 회사의 고의 또는
            중대한 과실로 인하여 발생한 손해의 경우는 제외합니다.
          </li>
          <li>
            제2항 제3호 내지 제5호의 경우에 회사는 기술상, 운영상 필요에 의해 서비스 전부를 중단할 수 있으며, 사전에 공지하고 서비스의 제공을 중단할
            수 있습니다. 사전에 공지할 수 없는 부득이한 사정이 있는 경우는 사후에 공지를 할 수 있습니다.
          </li>
          <li>회사가 부득이한 사유에 따라 서비스를 종료하는 경우 회원은 서비스 이용이 중단됨에 따른 손해배상을 청구할 수 없습니다.</li>
        </ol>
      </Article>
      <Article title="제 15조 (저작권 등의 귀속)">
        <ol>
          <li>서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 제휴계약에 따라 제공된 저작물 등은 제외합니다.</li>
          <li>
            회원은 회사가 제공하는 서비스를 이용함으로써 얻은 정보 중 회사 또는 제공업체에 지적재산권이 귀속된 정보를 회사 또는 제공업체의 사전승낙
            없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
          </li>
        </ol>
      </Article>
      <Article title="제 16조 (서비스 이용요금 등의 지급)">
        <ol>
          <li>이용자는 다음 각 호의 방법 중 가능한 방법으로 서비스 이용요금을 결제할 수 있습니다.</li>
          <ul>
            <li>무통장 입금 방식 (전자세금계산서 발행)</li>
            <li>신용카드 자동이체 결제 방식 (1개월 단위)</li>
          </ul>
          <li>
            신용카드 자동이체 결제 방식이란, 일정 기간마다 이용자가 사전에 승인한 신용카드로 서비스 이용요금을 자동으로 결제하는 방식을 말합니다.
            이용자가 회사가 정한 절차에 따라 자동 이체 결제 방식의 철회 의사를 밝히지 않는 한 자동으로 이용계약이 갱신되고 결제가 이뤄집니다.
          </li>
          <li>이용자는 서비스 이용 요금을 결제함에 있어 다음에 기재한 사유가 발생하지 않도록 유의하여야 합니다.</li>
          <ul>
            <li>이용자 본인 외에 결제수단 사용을 금지합니다.</li>
            <li>
              이용자는 결제수단의 비밀번호, 인증서 등의 유출로 인한 부정사용 또는 위변조 사고가 발생하지 않도록 주의하여야 합니다. 특히 이용자는
              신용카드의 미서명, 관리 소홀, 무단 대여나 양도 또는 담보제공으로 인한 부정사용, 불법 현금대출, 위변조 사조 등이 발생하지 않도록
              주의하여야 합니다.
            </li>
          </ul>
          <li>
            회사는 서비스 이용요금 결제가 정상적으로 이루어지지 않은 경우 이용자의 서비스 이용을 제한할 수 있으며, 서비스 이용요금을 미납하는 등
            이용자의 귀책 사유로 회사가 서비스 이용을 제한한 경우 이용자에게 발생한 손해에 대해서 회사는 면책됩니다.
          </li>
          <li>회사는 회사의 사정에 따라 결제 방식, 결제 수단을 추가, 삭제, 변경할 수 있으며, 사전에 그 사유와 적용일자를 공지합니다.</li>
        </ol>
      </Article>
      <Article title="제 17조 (서비스 이용요금 등의 고지)">
        <ol>
          <li>
            이용자는 청구된 서비스 이용요금 등에 대하여 매월 10일까지 내역 확인 후에 청구금액을 확정합니다. 단, 회사의 귀책사유로 과오납이 발생한
            경우, 이용자는 기간에 관계없이 청구된 서비스 이용요금 등에 대하여 이의 신청을 할 수 있습니다.
          </li>
          <li>회사는 제1항의 이의 신청 접수 후 1달 이내에 해당 이의신청을 타당성 여부를 조사하여 그 결과를 이용자에게 전달합니다.</li>
        </ol>
      </Article>
      <Article title="제 18조 (손해배상의 범위 및 청구)">
        <ol>
          <li>회사가 고의 또는 중과실로 회원에게 손해를 끼친 경우, 손해를 배상할 책임이 있습니다.</li>
          <li>이용자가 본 약관을 위반하거나 위법한 행위로 회사에 손해를 끼친 경우, 회원은 회사에 대하여 그 손해에 대하여 배상할 책임이 있습니다.</li>
        </ol>
      </Article>
      <Article title="제 19조 (면책)">
        <ol>
          <li>
            회사는 전시, 사변, 천재지변, 비상사태, 현재의 기술로는 해결이 불가능한 기술적 결함 기타 불가항력적 사유로 서비스를 제공할 수 없는 경우에는
            책임이 면제됩니다.
          </li>
          <li>회사는 이용자의 귀책사유로 인한 서비스의 중지, 이용장애 및 계약해지에 대하여 책임이 면제됩니다.</li>
          <li>
            회사는 기간통신 사업자가 전기통신서비스를 중지하거나 정상적으로 제공하지 아니하여 회원에게 손해가 발생한 경우에 대해서 회사의 고의 또는
            중대한 과실이 없는 한 책임이 면제됩니다.
          </li>
          <li>
            회사는 사전에 공지된 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한 경우에 대해서 회사의
            고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
          </li>
          <li>
            회사는 이용자의 컴퓨터 환경으로 인하여 발생하는 제반 문제 또는 회사의 고의 또는 중대한 과실이 없는 네트워크 환경으로 인하여 발생하는
            문제에 대해서 책임이 면제됩니다.
          </li>
          <li>
            회사는 이용자 상호간 또는 이용자와 제3자간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도
            없습니다.
          </li>
          <li>회사가 제공하는 서비스 중 무료 서비스의 경우에는 회사의 고의 또는 중대한 과실이 없는 한 회사는 손해배상을 하지 않습니다.</li>
          <li>
            본 서비스 중 일부의 서비스는 다른 사업자가 제공하는 서비스를 통하여 제공될 수 있으며, 회사는 다른 사업자가 제공하는 서비스로 인하여 발생한
            손해 등에 대해서는 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
          </li>
          <li>
            회사는 이용자의 컴퓨터 오류에 의한 손해가 발생한 경우 또는 신상정보 및 전자우편주소를 부정확하게 기재하거나 미기재하여 손해가 발생한
            경우에 대하여 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
          </li>
          <li>
            회사는 관련 법령, 정부 정책 등에 따라 서비스 또는 이용자에 따라 서비스 이용시간 등을 제한할 수 있으며, 이러한 제한사항 및 제한에 따라
            발생하는 서비스 이용 관련 제반사항에 대해서는 책임이 면제됩니다.
          </li>
        </ol>
      </Article>
      <Article title="제 20조 (분쟁조정)">
        <ol>
          <li>본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.</li>
          <li>
            서비스 이용과 관련하여 회사와 이용자 간에 발생된 분쟁에 대해서는 민사소송법 상의 회사의 본사소재지를 관할하는 법원을 합의관할로 합니다.
          </li>
          <li>
            해외에 주소나 거소가 있는 이용자의 경우 회사와 이용자간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 서울중앙지방법원을
            관할법원으로 합니다.
          </li>
        </ol>
      </Article>
    </>
  );
};

TermsOfService.defaultProps = {
  scrollable: undefined,
};

export default TermsOfService;
